import SignUp from '../components/sign-up/SignUp';

export default function SignUpPage() {
    return (
        <SignUp />
    );
};